import React, { useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';

const Index = props => {
	const [componentReady, setComponentReady] = useState();

	let classNames = 'icon';
	classNames += ' icon--' + props.name;
	if (props.classes) {
		classNames += props.classes.map(item => ' ' + item);
	}

	useEffect(() => {
		setComponentReady(true);
	});

	return (
		<>
			{componentReady && (
				<ReactSVG
					src={`/icons/${props.name}.svg`}
					wrapper="div"
					className={classNames}
					onClick={props.handleClick}
				/>
			)}
		</>
	);
};

Index.propTypes = {
	name: PropTypes.string.isRequired,
	classes: PropTypes.array,
};

export default Index;
